import { render, staticRenderFns } from "./add-group-rules.vue?vue&type=template&id=31dcd8ad&scoped=true&"
import script from "./add-group-rules.vue?vue&type=script&lang=js&"
export * from "./add-group-rules.vue?vue&type=script&lang=js&"
import style0 from "./add-group-rules.vue?vue&type=style&index=0&id=31dcd8ad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31dcd8ad",
  null
  
)

export default component.exports